const isProduction = process.env.REACT_APP_SENTRY_ENVIRONMENT === 'production';
const devConsole = isProduction ? null : console;

export default devConsole;
